import { IOrganization, IOrganizationSettingsCustomer } from "@/api";
import { createContext } from "react";

export interface OrganizationContextType {
    organization: IOrganization;
    settings: IOrganizationSettingsCustomer;
    /**
     * Fleet-tunable cap on documents attached directly to one conversation.
     *
     * Optional at this boundary even though the server always sends it: a
     * response cached from before the field shipped resolves to `undefined`,
     * and consumers must render the disabled/pending state rather than
     * substitute a literal that would disagree with the server the first time
     * the cap is retuned.
     */
    chatMaxDirectDocuments: number | undefined;
}

export const OrganizationContext = createContext<
    OrganizationContextType | undefined
>(undefined);
